import React, { useEffect, useState } from "react";
import ResourcesTab from "./ResourcesTab";
import { useDispatch, useSelector } from "react-redux";
import * as rssFeedActions from "../../store/breachesAndScamsService/actions";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { ApplicationState } from "../../store";
import i18nService from "../../util/Internationalization/i18n/i18n";
import RssFeedDetails from "./RssFeedDetails";
import { getFormattedDate } from "../../util/dateFormatting";
import LogoContainer from "../common/LogoContainer";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

const BreachesAndScams = () => {
    const dispatch = useDispatch();
    const isBusinessUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userServiceDetails?.isBusinessUser);
    const userType = isBusinessUser ? "business" : "personal";
    const requestData = () => dispatch(rssFeedActions.actionCreators.getRssFeedData(userType));
    const breachesAndScamsData = useSelector((state: ApplicationState) => (state.breachesAndScamsState ? state.breachesAndScamsState.breachesAndScamsData : []));
    const isLoading = useSelector((state: ApplicationState) => (state.breachesAndScamsState ? state.breachesAndScamsState.isLoading : false));
    const [isDetails, setIsDetails] = useState(false);
    const [detailFeedId, setDetailFeedId] = useState("");
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        requestData();
    });

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const changeFeedId = (feedUrl: string) => {
        const id = feedUrl.split("resources/")[1].replace("/", "");
        setDetailFeedId(feedUrl);
        changeDetailsView();
    };

    const changeDetailsView = () => {
        setIsDetails(!isDetails);
    };

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="resources-breaches-and-scams-page" tabIndex={-1}>
                        Resources
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ResourcesTab selectedTab="5" />

            {!isDetails ? (
                <div className="row" id="content">
                    <div className="col-xs">
                        <div className="box offset-padding">
                            {!isLoading ? (
                                <>
                                    <div className="box-header">
                                        <div className="box-title-container">
                                            <div className="box-title-icon" aria-hidden="true">
                                                <RenderIcons iconName="user-secret" />
                                            </div>
                                            <div className="box-title-text">
                                                <h2 className="box-title">Breaches &amp; Scams</h2>
                                            </div>
                                        </div>
                                        <div className="box-description">
                                            <p>
                                                Data breaches and scams are usually successful because they work quickly, unexpectedly and are often well-executed.
                                                Take a closer look at big-name data breaches and scams we've covered, and find out what you should do if you've been
                                                affected by them.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="box-content">
                                        <h3 className="content-sub-title sr-only">Breaches &amp; Scams Articles </h3>

                                        <ul className="article-list">
                                            {breachesAndScamsData != null &&
                                                breachesAndScamsData.map((data: any, index: number) => (
                                                    <li key={index}>
                                                        <div className="article-container">
                                                            <div className="article-image">
                                                                <a
                                                                    rel="noreferrer"
                                                                    onClick={() => {
                                                                        window.addToDataLayer({ event: "Breaches and Scams Articles Image" });
                                                                        changeFeedId(data.feedUrl);
                                                                    }}
                                                                    href="javascript:void(0);"
                                                                    aria-label={data.title}
                                                                    tabIndex={-1}
                                                                >
                                                                    <img
                                                                        style={{ left: "0%", top: "0%", transform: "none" }}
                                                                        src={data.imageUrl} alt="Article Image" />
                                                                </a>
                                                            </div>
                                                            <div className="article-content">
                                                                <h4 className="article-title">
                                                                    <a
                                                                        rel="noreferrer"
                                                                        onClick={() => {
                                                                            window.addToDataLayer({ event: "Breaches and Scams Articles Link" });
                                                                            changeFeedId(data.feedUrl);
                                                                        }}
                                                                        href="javascript:void(0);"
                                                                        title={data.title}
                                                                    >
                                                                        {data.title.length > 57 ? data.title.substring(0, 57) + "..." : data.title}
                                                                    </a>
                                                                </h4>
                                                                <div className="article-intro">
                                                                    <p style={{ maxHeight: "100px", textOverflow: "ellipsis", overflow: "hidden" }}>
                                                                        {data && data.summary && data.summary.length > 197 ? data.summary.substring(0, 197) + "..." : data.summary}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                        </ul>

                                        <div className="margin-vertical-xl"></div>

                                    </div>
                                </>
                            ) : (
                                <div className="box loading"></div>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                <RssFeedDetails id={detailFeedId} backToArticles={changeDetailsView} />
            )}
        </React.Fragment>
    );
};

export default BreachesAndScams;
